class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      'focusout',
      this.onFocusOut.bind(this)
    );

    this.mainDetailsToggle.addEventListener(
      'toggle',
      this.onToggle.bind(this)
    );
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    });
  }

  onToggle() {
    if (!this.animations) {
      this.animations = this.content.getAnimations();
    }

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');

    this.mainDetailsToggle
      .querySelector('summary')
      .setAttribute('aria-expanded', 'false');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);


class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();

    this.header = document.querySelector('.header-wrapper');
    this.closeTimer = null;

    this.mainDetailsToggle.addEventListener(
      'pointerenter',
      this.onPointerEnter.bind(this)
    );

    this.mainDetailsToggle.addEventListener(
      'pointerleave',
      this.onPointerLeave.bind(this)
    );
  }

  onPointerEnter(event) {
    if (event.pointerType !== 'mouse') return;

    clearTimeout(this.closeTimer);

    document.querySelectorAll('header-menu').forEach((menu) => {
      if (
        menu !== this &&
        menu.mainDetailsToggle &&
        menu.mainDetailsToggle.open
      ) {
        menu.close();
      }
    });

    this.mainDetailsToggle.open = true;

    this.mainDetailsToggle
      .querySelector('summary')
      .setAttribute('aria-expanded', 'true');
  }

  onPointerLeave(event) {
    if (event.pointerType !== 'mouse') return;

    clearTimeout(this.closeTimer);

    this.closeTimer = setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    }, 200);
  }

  onToggle() {
    if (!this.header) return;

    this.header.preventHide = this.mainDetailsToggle.open;

    this.mainDetailsToggle
      .querySelector('summary')
      .setAttribute(
        'aria-expanded',
        this.mainDetailsToggle.open ? 'true' : 'false'
      );

    if (
      document.documentElement.style.getPropertyValue(
        '--header-bottom-position-desktop'
      ) !== ''
    ) {
      return;
    }

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);